import WeighingPanel from '../../weighing/WeighingPanel';
import { WidgetOnlineWeighingProps } from '../Dashboard.types';

const DashboardWidgetOnlineWeighing = ({
 widget,
}: {
 widget?: WidgetOnlineWeighingProps;
}) => {
 return <WeighingPanel scaleId={widget?.scale?.Id ?? null} />;
};

export default DashboardWidgetOnlineWeighing;
